import { useMutation, useQueryClient } from '@tanstack/react-query';

import { parseApiError } from '@cast/api-client';
import { notify } from '@cast/design-system';
import { apiClient } from '@cast/infrastructure-api';

import { getEdgeConfigurationsQueryKey } from 'hooks/queries/omni/useListEdgeConfigurationsQuery';
import { useOrganizations } from '@cast/shared-organization-context-data-access';

type UseDeleteEdgeConfigurationMutationProps = {
  clusterId: string;
  onSuccess?: () => void;
};

export const useDeleteEdgeConfigurationMutation = ({
  clusterId,
  onSuccess,
}: UseDeleteEdgeConfigurationMutationProps) => {
  const queryClient = useQueryClient();
  const { currentOrganization } = useOrganizations();

  return useMutation({
    mutationFn: ({
      edgeConfigurationId,
      edgeLocationId,
    }: {
      edgeConfigurationId: string;
      edgeLocationId: string;
    }) => {
      return apiClient.omni.deleteEdgeConfiguration({
        organizationId: currentOrganization!.id,
        clusterId,
        edgeLocationId,
        id: edgeConfigurationId,
      });
    },
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: getEdgeConfigurationsQueryKey({}),
      });
      notify.success('Edge configuration deleted successfully!');
      onSuccess?.();
    },
    onError: (error: unknown) => {
      notify.error(parseApiError(error));
    },
  });
};
